module.exports = __webpack_public_path__ + "img/ida_far.7a0edee9.png";